export default __webpack_public_path__ + "static/media/Q13_3_resized.459ce5dd.jpg";